// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YxNsj","header":"Table_header__xImn-","pointer":"Table_pointer__ORcPa","cell":"Table_cell__0RgLK"};